export const GET_CONFIG = 'GET_CONFIG';
export const GET_CONFIG_SUCCESS = 'GET_CONFIG_SUCCESS';
export const GET_CONFIG_ERROR = 'GET_CONFIG_ERROR';
export const GET_CURRENCY_CONFIG = 'GET_CURRENCY_CONFIG';
export const GET_CURRENCY_CONFIG_SUCCESS = 'GET_CURRENCY_CONFIG_SUCCESS';
export const GET_CURRENCY_CONFIG_ERROR = 'GET_CURRENCY_CONFIG_ERROR';
export const GET_REFERENCE_COUNTRIES = 'GET_REFERENCE_COUNTRIES';
export const GET_REFERENCE_COUNTRIES_SUCCESS = 'GET_REFERENCE_COUNTRIES_SUCCESS';
export const GET_REFERENCE_COUNTRIES_ERROR = 'GET_REFERENCE_COUNTRIES_ERROR';
export const GET_USER_CONFIG_SUCCESS = 'GET_USER_CONFIG_SUCCESS';

export const getConfig = () => ({
  type: GET_CONFIG,
});

export const getCurrencyConfig = (currencyCode) => ({
  type: GET_CURRENCY_CONFIG,
  payload: currencyCode,
});

export const getReferenceCountries = () => ({
  type: GET_REFERENCE_COUNTRIES,
});
